module.exports = __webpack_public_path__ + "img/alentour9.70e925ce.jpg";